import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// HOCs
import withFormManagement from 'hocs/WithFormManagement';
// Models
import mServiceFeeRule from 'models/cpm/serviceFeeRule';
// Custom
import { fullListShape } from 'constants/PropTypesShapes';
import SubListTemplate from 'components/templates/SubListTemplate';
import ServiceFeeRuleFilters from 'cpmWorkspaces/assets/serviceFeeRule/ServiceFeeRuleFilters';
import ServiceFeeRuleRow from 'cpmWorkspaces/assets/serviceFeeRule/ServiceFeeRuleRow';

class ServiceFeeRuleChooseList extends React.Component {
  constructor(props) {
    super(props);

    this.doGetRowComp = this.doGetRowComp.bind(this);
    this.handleSelectServiceFeeRule = this.handleSelectServiceFeeRule.bind(this);
    this.handleValidate = this.handleValidate.bind(this);
  }

  componentDidMount() {
    // We need to pass component reference to parent (= DialogItem)
    const { onRef } = this.props;
    onRef(this);
  }

  // Handlers called by parent (= DialogItem)
  handleValidate() {
    const {
      fields: { selectedServiceFeeRule },
      onValidate,
    } = this.props;

    return onValidate(selectedServiceFeeRule);
  }

  handleSelectServiceFeeRule(selectedServiceFeeRule) {
    const { onFieldsChange } = this.props;

    onFieldsChange({ selectedServiceFeeRule });
  }

  // Private
  doGetRowComp(props) {
    return <ServiceFeeRuleRow {...props} />;
  }

  render() {
    const {
      dispatchListServiceFeeFules,
      fields: { selectedServiceFeeRule },
      serviceFeeRulesList,
    } = this.props;

    return (
      <SubListTemplate
        withQueryParams={false}
        name="serviceFeeRule"
        listFeatures={mServiceFeeRule.chooseListFeatures}
        withSelection
        onSelectElements={this.handleSelectServiceFeeRule}
        elementsData={{
          loading: serviceFeeRulesList.loading,
          selectedElement: selectedServiceFeeRule,
          elements: serviceFeeRulesList.elements,
          handleGetList: dispatchListServiceFeeFules,
        }}
        filtersComp={(
          <ServiceFeeRuleFilters listFeatures={mServiceFeeRule.chooseListFeatures} noPadding />
        )}
        rowComp={this.doGetRowComp}
      />
    );
  }
}

ServiceFeeRuleChooseList.propTypes = {
  dispatchListServiceFeeFules: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  onFieldsChange: PropTypes.func.isRequired,
  onRef: PropTypes.func.isRequired,
  onServiceFeeRulesListAction: PropTypes.func.isRequired,
  onServiceFeeRulesListStateGetter: PropTypes.func.isRequired,
  onValidate: PropTypes.func,
  serviceFeeRulesList: fullListShape.isRequired,
};

ServiceFeeRuleChooseList.defaultProps = {
  onValidate: null,
};

const mapFieldsToProps = {
  selectedServiceFeeRule: {
    defaultValue: null,
    resourceKey: 'serviceFeeRule',
  },
};

const mapOwnPropsToResources = (ownProps) => ({
  resourceData: ownProps,
});

const mapStateToProps = (state, ownProps) => {
  const { onServiceFeeRulesListStateGetter } = ownProps;

  return { serviceFeeRulesList: onServiceFeeRulesListStateGetter(state) };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { onServiceFeeRulesListAction } = ownProps;

  return {
    dispatchListServiceFeeFules: (pagination, sort, filters) => {
      dispatch(onServiceFeeRulesListAction(pagination, sort, filters));
    },
  };
};

module.exports = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withFormManagement(mapFieldsToProps, mapOwnPropsToResources, false),
)(ServiceFeeRuleChooseList);



// WEBPACK FOOTER //
// ./routes/cpm/routes/workspaces/assets/serviceFeeRule/ServiceFeeRuleChooseList.js